import { Link } from "react-router-dom";
import { Helmet } from "react-helmet-async";
import { Gift, FilmSlate, Broadcast, BookmarkSimple } from "@phosphor-icons/react";
import { Header } from "@/components/Header";

const PERKS = [
  { icon: FilmSlate, title: "Every Film, Free", text: "The entire catalog of indie films, full-length movies and music videos streams at no cost — no subscription, ever." },
  { icon: Broadcast, title: "Live, Free Too", text: "Creator streams, audio lounges and 24/7 news on ReelVault Live carry no paywall." },
  { icon: BookmarkSimple, title: "Your Vault, Free", text: "Save titles to watch later on any device — no account required." },
];

export default function Store() {
  return (
    <div className="min-h-screen bg-[#050505]">
      <Helmet>
        <title>Store · ReelVault</title>
      </Helmet>
      <Header />

      <main className="mx-auto max-w-[1100px] px-5 sm:px-8 py-20 rv-fade text-center">
        <span className="inline-flex items-center gap-2 border border-emerald-500/50 bg-emerald-500/10 px-4 py-1.5 font-mono text-[11px] uppercase tracking-[0.2em] text-emerald-400">
          <Gift size={16} weight="duotone" /> Nothing to buy
        </span>
        <h1 className="mt-6 font-serif text-4xl sm:text-5xl lg:text-6xl tracking-tighter text-[#EDEDED] leading-[1.05]">
          It's all <span className="text-emerald-400">Free</span> at ReelVault
        </h1>
        <p className="mx-auto mt-4 max-w-xl text-white/55 text-sm leading-relaxed">
          There's no store cart here — ReelVault is a free independent media aggregator. For select Hollywood titles,
          we simply point you to where they legally stream or rent via JustWatch.
        </p>

        <div className="mt-14 grid gap-6 sm:grid-cols-3 text-left">
          {PERKS.map((p) => {
            const Icon = p.icon;
            return (
              <div key={p.title} className="border border-white/10 bg-[#0A0A0A] p-6">
                <Icon size={30} weight="duotone" className="text-amber" />
                <h3 className="mt-4 font-serif text-xl text-[#EDEDED]">{p.title}</h3>
                <p className="mt-2 text-white/50 text-sm leading-relaxed">{p.text}</p>
              </div>
            );
          })}
        </div>

        <Link
          to="/"
          data-testid="store-browse-btn"
          className="mt-14 inline-flex items-center gap-2 bg-amber text-black px-6 py-3 font-mono text-xs uppercase tracking-[0.15em] hover:bg-crimson hover:text-white transition-colors duration-300"
        >
          Start Browsing — Free
        </Link>
      </main>
    </div>
  );
}
